import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import moment from "moment";
import { formatarDecimalNumber, formatarValorMonetario } from "../../../../../../../../helpers/masks";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useState } from "react";
import DialogMemoriaCalculo from "./DialogMemoriaCalculo";
import { MemoriaCalculo, valoresTitulos } from "../../../../../../../../types/api/financeiro/simular-recebimento-titulos";

export default function DialogDetalhesTitulos({
  open,
  titulosDetalhes,
  onClose,
  totalAtualizado
}: DialogDetalharTitulosProps) {

  const [memoriaCalculo, setMemoriaCalculo] = useState<MemoriaCalculo[] | null>(null);

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>
          Detalhes Títulos
        </DialogTitle>
        <DialogContent>
          <TableContainer sx={{ border: "1px solid #ccc", borderRadius: 2 }}>
            <Table size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell><b>Título</b></TableCell>
                  <TableCell><b>Vencimento</b></TableCell>
                  <TableCell align="right"><b>Saldo atual</b></TableCell>
                  <TableCell align="right"><b>Juros, multa e correção</b></TableCell>
                  <TableCell align="right"><b>Valor atualizado</b></TableCell>
                  <TableCell align="right"></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>

                {
                  titulosDetalhes.map((item, index) => {
                    const valorJuros = item.valor_atualizado - item.saldo;
                    const prctJutos = ((valorJuros / item.saldo) * 100);

                    return (
                      <TableRow
                        key={index}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell>{item.titulo}</TableCell>
                        <TableCell>{moment(item.data_vencimento, 'YYYY-MM-DD').format('DD/MM/YYYY (ddd)').replace(/\((\w)/, (match, p1) => `(${p1.toUpperCase()}`)}</TableCell>
                        <TableCell align="right">{formatarValorMonetario(item.saldo)}</TableCell>
                        <TableCell align="right">{formatarDecimalNumber(prctJutos)}% ({formatarValorMonetario(valorJuros)})</TableCell>
                        <TableCell align="right">{formatarValorMonetario(item.valor_atualizado)}</TableCell>
                        <TableCell align="right">
                          <Button
                            size="small"
                            variant="text"
                            onClick={() => setMemoriaCalculo(item.memoria_calculo)}
                            startIcon={<VisibilityIcon />}
                          >
                            Memória de cálculo
                          </Button>
                        </TableCell>
                      </TableRow>
                    )
                  })
                }
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Stack
            mx={2}
            width={'100%'}
            direction={'row'}
            justifyContent={'space-between'}
          >
            <Stack direction={'row'} alignItems={'flex-end'} spacing={1}>
              <Typography
                variant="subtitle1"
              >
                Valor atualizado
              </Typography>

              <Typography
                variant="h6"
                fontWeight={'bold'}
              >
                {formatarValorMonetario(totalAtualizado)}
              </Typography>
            </Stack>

            <Button
              variant="outlined"
              onClick={onClose}
            >
              Fechar
            </Button>

          </Stack>
        </DialogActions>
      </Dialog>

      {
        memoriaCalculo &&
        <DialogMemoriaCalculo
          open={true}
          memoriaCalculo={memoriaCalculo}
          onClose={() => setMemoriaCalculo(null)}
        />
      }
    </>
  )
}
interface DialogDetalharTitulosProps {
  open: boolean;
  onClose: () => void
  titulosDetalhes: valoresTitulos[],
  totalAtualizado: number
}